module.exports = __webpack_public_path__ + "images/emoji/u6e80.75e58ef818a611e8413a.png";